export const routes = {
  root: "/",
  add: "add",
  edit: "edit",
  view: "view",
  id: ":id",
  action: ":action",
  planId: ":planId",
  planAction: ":planAction",
  admin: "admin",
  login: "login",
  changePassword: "change-password",
  forgotPassword: "forgot-password",
  resetPasswordOtp: "reset-password-otp",
  dashboard: "dashboard",
  masterData: "master-data",
  category: "category",
  tabRowId: ":tabRowId",
  tabRowAction: ":tabRowAction",
  role: "role",
  subCategory: "sub-category",
  employeeMgmt: "employee-mgmt",
  clientMgmt: "client-mgmt",
  projectOverview: "project-overview",
  projectInfo: "project-info",
  taskCategory: "task-category",
  qualityChecklist: "quality-checklist",
  safetyChecklist: "safety-checklist",
  teamAssignment: "team-assignment",
  pm: "pm",
  projectPlan: "project-plan",
  projectDocDesign: "project-doc-design",
  taskHierarchy: "task-hierarchy"
};
